export default (() => {
  const __VERSION__ = "4.0.0";
  const [MAJOR, MINOR, PATCH] = __VERSION__.split(".").map(Number);
  return {
    MAJOR,
    MINOR,
    PATCH,
  };
})();
